import { useContext } from 'react'
import { ConfirmContext, IConfirmProps } from './ConfirmProvider'

const useConfirm = () => {
  const confirm = useContext(ConfirmContext)
  return confirm === null ? (options: IConfirmProps) => new Promise((resolve, reject) => resolve()) : confirm
}

export default useConfirm
